export enum reportTypes {
    END_REPORT = "END_REPORT",
    GET_MISSING_COLUMNS = "GET_MISSING_COLUMNS",
    GET_PHONE_ISSUES = "GET_PHONE_ISSUES",
    GET_MAIL_ISSUES = "GET_MAIL_ISSUES",
    GET_FILE_STATUS = "GET_FILE_STATUS",
    GET_HEADER = "GET_HEADER",
}
  
export default reportTypes;